<template>
  <div class="main_div">
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1>내 정보관리</h1>
      </div>
      <div class="contents_wrap">
        <div class="small_title_wrap">
          <h2>기본 정보</h2>
        </div>
        <ul class="filter_list">
          <li class="col3">
            <dd>
              <label>성명</label>
              <ul>
                <li>
                  {{ userInfo.userNm }}
                </li>
              </ul>
            </dd>
<!--            <dd>-->
<!--              <label>근무지 전화번호</label>-->
<!--              <div v-show="workTelNoUpdateYn === 'N'">-->
<!--                <ul>-->
<!--                  <li>-->
<!--                    <div :style="'width: 70%; display: inline-block'">-->
<!--                      {{ userInfo.workTelNo }}-->
<!--                    </div>-->
<!--                    <button-->
<!--                        @click="updateStart($event)"-->
<!--                        name="workTelNoButton"-->
<!--                        class="w25 mid_btn"-->
<!--                        :style="'margin-left:1%'">변경하기</button>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </div>-->
<!--              <div v-show="workTelNoUpdateYn === 'Y'">-->
<!--                <ul>-->
<!--                  <kendo-maskedtextbox-->
<!--                      ref="workTelNoRef"-->
<!--                      name="workTelNo"-->
<!--                      v-model="userInfo.workTelNo"-->
<!--                      :style="'width: 70%;'"-->
<!--                  >-->
<!--                  </kendo-maskedtextbox>-->
<!--                  <button-->
<!--                      @click="updateComplete($event)"-->
<!--                      class="w25 mid_btn orange"-->
<!--                      :style="'margin-left:1%'">저장하기</button>-->
<!--                </ul>-->
<!--              </div>-->
<!--            </dd>-->
            <dd>
              <label>회사명</label>
              <ul>
                <li>
                  {{ userInfo.cmpyNm }}
                </li>
              </ul>
            </dd>
            <dd>
              <label>업무공간</label>
              <ul>
                <li>
                  {{ !!userInfo.wsNm ? userInfo.wsNm : '-' }}
                </li>
              </ul>
            </dd>
          </li>
          <li class="col3">
            <dd>
              <label>ID</label>
              <ul>
                <li>
                  {{ userInfo.userId }}
                </li>
              </ul>
            </dd>
            <dd>
              <label>휴대폰 번호</label>
              <div v-show="spTelNoUpdateYn === 'N'">
                <ul>
                  <li>
                    <div :style="'width: 70%; display: inline-block'">
                      {{ userInfo.spTelNo }}
                    </div>
                    <button
                        @click="updateStart($event)"
                        name="spTelNoButton"
                        class="w25 mid_btn"
                        :style="'margin-left:1%'">변경하기</button>
                  </li>
                </ul>
              </div>
              <div v-show="spTelNoUpdateYn === 'Y'">
                <ul>
                  <kendo-maskedtextbox
                      ref="spTelNoRef"
                      name="spTelNo"
                      v-model="userInfo.spTelNo"
                      :style="'width: 70%;'"
                  >
                  </kendo-maskedtextbox>
                  <button
                      @click="updateComplete($event)"
                      class="w25 mid_btn orange"
                      :style="'margin-left:1%'">저장하기</button>
                </ul>
              </div>
            </dd>
            <dd>
              <label>이메일</label>
              <div v-show="emailUpdateYn === 'N'">
                <ul>
                  <li>
                    <div :style="'width: 70%; display: inline-block'">
                      {{ userInfo.email }}
                    </div>
                    <button
                        @click="updateStart($event)"
                        name="emailButton"
                        class="w25 mid_btn"
                        :style="'margin-left:1%'">변경하기</button>
                  </li>
                </ul>
              </div>
              <div v-show="emailUpdateYn === 'Y'">
                <ul>
                  <kendo-maskedtextbox
                      ref="emailRef"
                      name="email"
                      v-model="userInfo.email"
                      :style="'width: 70%;'"
                  >
                  </kendo-maskedtextbox>
                  <button
                      @click="updateComplete($event)"
                      class="w25 mid_btn orange"
                      :style="'margin-left:1%'">저장하기</button>
                </ul>
              </div>
            </dd>
          </li>
          <li class="col3">
            <dd>
              <label>비밀번호</label>
              <div v-show="userPwdUpdateYn === 'N'">
                <ul>
                  <li>
                    <button
                        @click="openDoubleCheckWindow"
                        class="w25 mid_btn">변경하기</button>
                  </li>
                </ul>
              </div>
            </dd>
            <dd>
              <label>사업장</label>
              <div>
                <ul>
                  <li>
                    <div v-show="facilityUpdateYn === 'N'">
                      <div :style="'width: 70%; display: inline-block'">{{ userInfo.facilityNm === null ? '-' : userInfo.facilityNm }}</div>
                      <button
                          @click="updateStart($event)"
                          name="facilityButton"
                          class="w25 mid_btn"
                          :style="'margin-left:1%'">변경하기</button>
                    </div>
                    <div v-show="facilityUpdateYn === 'Y'">
                      <kendo-dropdownlist
                          ref="facilityRef"
                          name="facility"
                          class="w70"
                          :option-label="'선택 안함'"
                          :data-source="zone1DepthList"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          v-model="userInfo.facility"
                          @change="onChangeFacility"
                      >
                      </kendo-dropdownlist>
                      <button
                          @click="updateComplete($event)"
                          class="w25 mid_btn orange"
                          :style="'margin-left:1%'">저장하기</button>
                    </div>
                  </li>
                </ul>
              </div>
            </dd>
            <dd>
              <label>거점</label>
              <div>
                <ul>
                  <li>
                    <div v-show="areaUpdateYn === 'N'">
                      <div :style="'width: 70%; display: inline-block'">{{ userInfo.areaNm === null ? '-' : userInfo.areaNm }}</div>
                      <button
                          @click="updateStart($event)"
                          name="areaButton"
                          class="w25 mid_btn"
                          :style="'margin-left:1%'">변경하기</button>
                    </div>
                    <div v-show="areaUpdateYn === 'Y'">
                      <kendo-dropdownlist
                          ref="areaRef"
                          name="area"
                          class="w70"
                          :option-label="'선택 안함'"
                          :data-source="zone2DepthList"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          v-model="userInfo.area"
                      >
                      </kendo-dropdownlist>
                      <button
                          @click="updateComplete($event)"
                          class="w25 mid_btn orange"
                          :style="'margin-left:1%'">저장하기</button>
                    </div>
                  </li>
                </ul>
              </div>
            </dd>
          </li>
        </ul>
      </div>
      <div class="contents_wrap">
        <div class="small_title_wrap">
          <h2>개인 권한 정보</h2>
        </div>
        <ul class="filter_list">
          <li>
            <dd>
              <label class="w30">관리자 여부</label>
              <ul>
                <li>
                  {{ userInfo.isAdmin }}
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label class="w30">이용약관/개인정보활용동의</label>
              <ul>
                <li>
                  <span class="org mr10"> {{ userInfo.clsAgrYn }} </span>
                  동의 일시: {{ userInfo.clsAgrDt }}
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label class="w30">IP 접근 제어 설정<span class="forg">*</span></label>
              <ul>
                <li style="display:flex; align-items:flex-start; line-height:1.9; padding-top:5px;">
                  <span class="mr10" :class="userInfo.ipPolicyYn === 'Y' ? 'org' : ''">
                    {{ userInfo.ipPolicyYn }}
                  </span>
                  <span
                      v-if="userInfo.ipPolicyYn === 'Y' && userInfo.allowIpList && userInfo.allowIpList.length > 0"
                      class="ip-grid">
                    <template v-for="(item, idx) in userInfo.allowIpList">
                      <span :key="'ip' + idx" class="ip-addr">{{ item.ipAddress }}/{{ item.cidrPrefix }}</span>
                      <span :key="'dt' + idx" class="ip-date">{{ item.frstRgstDt }}</span>
                    </template>
                  </span>
                </li>
              </ul>
            </dd>
          </li>
        </ul>
      </div>
      <div class="contents_wrap">
        <div class="small_title_wrap">
          <h2>마케팅 활용 동의
            <kendo-switch :checked="userInfo.mktAgrYn === 'Y'" class="mr25" @change="onChangeMktAgrYnSwitch"></kendo-switch>
          </h2>
        </div>
        <ul class="filter_list">
          <li>
            <label>이메일 수신 여부</label>
            <ul>
              <li>
                <kendo-switch :checked="userInfo.mktEmailAgrDt !== null" class="mr25" @change="onChangeMktEmailAgrYnSwitch"></kendo-switch>
                <span v-if="userInfo.mktEmailAgrDt!=null">
                  동의 일시: {{userInfo.mktEmailAgrDt}}
                </span>
              </li>
            </ul>
          </li>
          <p>
            이메일 수신동의를 하시면 메일을 통해 ES KIOSK 정보 및 여러가지 회원 혜택등의 정보를 우선적으로 받아보실 수 있습니다.<br/>
            회원가입 및 서비스 변경 등의 메일은 수신동의와 상관없이 모든 회원에게 발송됩니다.
          </p>
          <li>
            <label>SMS 수신 여부</label>
            <ul>
              <li>
                <kendo-switch :checked="userInfo.mktSmsAgrDt !== null" class="mr25" @change="onChangeMktSmsAgrYnSwitch"></kendo-switch>
                <span v-if="userInfo.mktSmsAgrDt!=null">
                  동의 일시: {{userInfo.mktSmsAgrDt}}
                </span>
              </li>
            </ul>
          </li>
          <p>
            SMS 수신동의를 하시면 SMS를 통해 ES KIOSK 정보 및 여러가지 회원 혜택등의 정보를 우선적으로 받아보실 수 있습니다.<br/>
            회원가입 및 서비스 변경 등의 SMS는 수신동의와 상관없이 모든 회원에게 발송됩니다.
          </p>
        </ul>
      </div>
    </section>
    <check-pwd-window
        ref="pwdCheckWindowRef"
    >
    </check-pwd-window>
  </div>
</template>

<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import EtnersParseUtil from '@/common/etners.parse.util'

import CheckPwdWindow from "@/components/CheckPwdWindow"
import {ZoneMixin} from "@/mixin/Mixin";
import EtnersPasswordUtil from '@/common/etners.password.util'
import EtnersEncDecUtil from '@/common/etners.encDec.util'
import EtnersCommonUtil from '@/common/etners.common.util'


export default {
  name: 'MyPage',
  components: {CheckPwdWindow},
  mixins: [ZoneMixin],
  created () {
    const vm = this
    vm.getUserInfo()
  },

  methods: {
    openDoubleCheckWindow () {
      const vm = this
      const kendoWindowRef = vm.$refs.pwdCheckWindowRef.$refs.kendoWindowRef
      kendoWindowRef.kendoWidget().center().open()
    },

    getNow() {
      const today = new Date()
      const year = today.getFullYear()
      const month = ('0' + (today.getMonth() + 1)).slice(-2)
      const day = ('0' + today.getDate()).slice(-2)
      const hours = ('0' + today.getHours()).slice(-2)
      const minutes = ('0' + today.getMinutes()).slice(-2)

      return `${year}-${month}-${day} ${hours}:${minutes}`
    },

    onChangeMktAgrYnSwitch (e) {
      const vm = this
      let mktAgrYn = vm.userInfo.mktAgrYn
      let mktEmailAgrDt = vm.userInfo.mktEmailAgrDt
      let mktSmsAgrDt = vm.userInfo.mktSmsAgrDt

      if (e.checked) {
        mktAgrYn = 'Y'
        mktEmailAgrDt = vm.getNow()
        mktSmsAgrDt = vm.getNow()

      } else {
        mktAgrYn = 'N'
        mktEmailAgrDt = null
        mktSmsAgrDt = null
      }
      vm.updateMktYn(mktAgrYn, mktEmailAgrDt, mktSmsAgrDt)
    },

    onChangeMktEmailAgrYnSwitch (e) {
      const vm = this
      let mktAgrYn = vm.userInfo.mktAgrYn
      let mktEmailAgrDt = vm.userInfo.mktEmailAgrDt
      let mktSmsAgrDt = vm.userInfo.mktSmsAgrDt

      if (e.checked) {
        mktEmailAgrDt = vm.getNow()
        mktAgrYn = 'Y'
      } else {
        mktEmailAgrDt = null
        if(mktSmsAgrDt === null){
          mktAgrYn = 'N'
        }
      }
      vm.updateMktYn(mktAgrYn, mktEmailAgrDt, mktSmsAgrDt)
    },

    onChangeMktSmsAgrYnSwitch (e) {
      const vm = this
      let mktAgrYn = vm.userInfo.mktAgrYn
      let mktEmailAgrDt = vm.userInfo.mktEmailAgrDt
      let mktSmsAgrDt = vm.userInfo.mktSmsAgrDt

      if (e.checked) {
        mktSmsAgrDt = vm.getNow()
        mktAgrYn = 'Y'
      } else {
        mktSmsAgrDt = null
        if(mktEmailAgrDt === null){
          mktAgrYn = 'N'
        }
      }
      vm.updateMktYn(mktAgrYn, mktEmailAgrDt, mktSmsAgrDt)
    },

    onChangeFacility () {
      const vm = this

      vm.onChange1Depth('facilityRef')
      vm.userInfo.area = null
      vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)
    },

    updateMktYn(mktAgrYn, mktEmailAgrDt, mktSmsAgrDt) {
      const vm = this

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/user/updateMktAgrYnForMyPage.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        mktAgrYn: mktAgrYn,
        mktEmailAgrDt: mktEmailAgrDt,
        mktSmsAgrDt: mktSmsAgrDt
      }

      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }

        vm.userInfo.mktAgrYn =mktAgrYn
        vm.userInfo.mktEmailAgrDt =mktEmailAgrDt
        vm.userInfo.mktSmsAgrDt =mktSmsAgrDt
      })
    },

    updateStart(e) {
      const vm = this
      const clickedButton = e.target.name
      vm.workTelNoUpdateYn = 'N'
      vm.spTelNoUpdateYn = 'N'
      vm.emailUpdateYn = 'N'
      vm.facilityUpdateYn = 'N'
      vm.areaUpdateYn = 'N'

      switch (clickedButton){
        case 'workTelNoButton':
          vm.workTelNoUpdateYn = 'Y'
          break
        case 'spTelNoButton':
          vm.spTelNoUpdateYn = 'Y'
          break
        case 'emailButton':
          vm.emailUpdateYn = 'Y'
          break
        case 'facilityButton':
        case 'areaButton':
          vm.facilityUpdateYn = 'Y'
          vm.areaUpdateYn = 'Y'
          vm.onChange1Depth('facilityRef')
          break
      }
    },

    updateComplete(e) {
      const vm = this

      const regEmail = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/
      if(!regEmail.test(vm.userInfo.email)){
        kendo.alert('이메일 형식을 확인해주세요.')
        return
      }

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/user/updateUserInfoForMyPage.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        workTelNo: vm.userInfo.workTelNo !== '-' ? vm.userInfo.workTelNo : null,
        spTelNo: vm.userInfo.spTelNo !== '-' ? vm.userInfo.spTelNo : null,
        email: vm.userInfo.email,
        facility: vm.userInfo.facility,
        area: vm.userInfo.area,
      }

      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        kendo.alert('정보가 변경되었습니다.')

        vm.workTelNoUpdateYn = 'N'
        vm.spTelNoUpdateYn = 'N'
        vm.emailUpdateYn = 'N'
        vm.facilityUpdateYn = 'N'
        vm.areaUpdateYn = 'N'

        // loginUserData 세팅
        const resultData = response.data.resultData
        let loginUserData = JSON.parse(sessionStorage.getItem("loginUserData"))
        loginUserData.facility = resultData.facility
        loginUserData.area = resultData.area
        sessionStorage.setItem("loginUserData", JSON.stringify(loginUserData))

        vm.getUserInfo()
      })
    },

    getUserInfo : function () {
      const vm = this

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/user/userInfoForMyPage.json`
      const param = {
        loginUserToken: vm.loginUserToken
      }

      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        resultData.spTelNo = EtnersParseUtil.convertTelNo(resultData.spTelNo)
        resultData.workTelNo = EtnersParseUtil.convertTelNo(resultData.workTelNo)

        vm.userInfo = resultData
      })
    },
  },

  data: function() {
    const vm = this
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }

    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      userInfo:{},
      newUserPwd: '',
      workTelNoUpdateYn: 'N',
      spTelNoUpdateYn: 'N',
      emailUpdateYn: 'N',
      userPwdUpdateYn: 'N',

      facilityUpdateYn: 'N',
      areaUpdateYn: 'N',

    }
  }
}
</script>

<style scoped>
.ip-grid {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 14px;
  row-gap: 2px;
}
.ip-date {
  color: #adb5bd;
}
</style>
